(function() {
    'use strict';

    angular.module('app.inscripciones', []);
})();
